import React from 'react';
import Link from '../Link';
import IconLink from '../Icons/IconLink';

export type LinkProps = {
  href: string;
};
const TExternalLink: React.FC<LinkProps> = ({ href }) => {
  const handleClick = (event) => event.stopPropagation();

  return (
    <Link
      href={href}
      icon={<IconLink size="xl" fill="#52AEFF" />}
      target="_blank"
      onClick={handleClick}
    />
  );
};

export default TExternalLink;
